import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { unFormatCurrency, unFormatUnknownUnit } from '@/common/utils/unFormatters';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { DiagnosticPieceData } from '../../../../types/forwardings/directiveEntries/diagnosticEntry/diagnosticEntry.type';
import { DiagnosticObjectivePieceValidationSchema } from '../../schemas/diagnosticObjectivePiece.schema';

interface UseUpdateDiagnosticObjectivePieceProps {
  diagnosticObjectivePiece: DiagnosticPieceData | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse,
    DiagnosticObjectivePieceValidationSchema
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useUpdateDiagnosticObjectivePiece = ({
  diagnosticObjectivePiece,
  options,
}: UseUpdateDiagnosticObjectivePieceProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['updateDiagnosticObjectivePiece', diagnosticObjectivePiece?.id],
    mutationFn: (form) => {
      const payload = {
        description: form.description,
        unit_price: form.unit_price && unFormatCurrency(form.unit_price),
        quantity: form.quantity && unFormatUnknownUnit(form.quantity),
        warranty_in_days: form.warranty_in_days && unFormatUnknownUnit(form.warranty_in_days),
      }

      return privateAxios.put(`/maintenance/diagnostic_objective_pieces/${diagnosticObjectivePiece?.id}`, {
        ...payload,
      });
    },
    ...options
  });
}
